'use strict'

/**
 *
 * @name: nnGeneralSidenav
 *
 */
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import DirectiveTemplate from './nn-general-sidenav.directive.html'
import './nn-general-sidenav.directive.scss'

function NnGeneralSidenavDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: DirectiveTemplate,
    controller: DirectiveController
  }
}

function DirectiveController ($scope, $rootScope, $element) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */

  $scope.isOpened = false
  $scope.navigation = [
    {
      link: '//www.dazeddigital.com',
      icon: 'dazed-logo'
    },
    {
      link: '//www.dazeddigital.com/beauty',
      icon: 'beauty-logo'
    },
    {
      link: '//www.dazeddigital.com/dazed100',
      icon: 'dazed100-logo'
    },
    {
      link: '//www.anothermag.com',
      icon: 'another-logo'
    },
    {
      link: '//www.anothermanmag.com/',
      icon: 'anotherman-logo'
    }
  ]


  /*
   *
   * @PUBLIC
   *
   */

  $scope.className = () => ({
    'nn-general-sidenav--opened': $scope.isOpened
  })

  $scope.toggleVisibility = val => {
    if (val === undefined) {
      $scope.isOpened = !$scope.isOpened
    } else {
      $scope.isOpened = val
    }

    if ($scope.isOpened) {
      disableBodyScroll($element[0]);
    } else {
      enableBodyScroll($element[0]);
    }
  }


  /*
   *
   * @PRIVATE
   *
   */



  /*
   *
   * @INIT
   *
   */
}

export default NnGeneralSidenavDirective



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-general-sidenav/nn-general-sidenav.directive.js